import { defineStore } from 'pinia'
import discoverService from '@/service/discoverService'

export const useConnectionStore = defineStore('connectionStore', {
  state: () => ({}),

  getters: {},

  actions: {
    async discoverIPAddress(macAddress: string) {
      const data = await discoverService.fetchIPAddressByMacAddress({
        macAddress: macAddress,
      })

      return data
    },
  },
})
